import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';
import Service from './Service';
import Cookies from 'js-cookie';

const afterParser = (response) => {
  return response.data;
};

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

class SheetImporterTagsService extends Service {
  constructor(gateway) {
    const api = createApi('/se-studio-service/import/tag-posts/xlsx', gateway, {
      authNotFound: () => true,
      error401Handler,
    });
    super(api, { afterParser });

    this.api.http.defaults.timeout = 300000;
  }

  importSheetToTagPosts(formdata, queryString) {
    const headers = {
      'stilingue-session-id': Cookies.get('stilingue-session-id'),
      'Content-Type': 'multipart/form-data',
    };
    const config = {
      params: queryString,
      crossDomain: true,
      headers,
    };
    return this.update(formdata, config);
  }
}

export default new SheetImporterTagsService(gateway);
